module.exports = __webpack_public_path__ + "static/media/feedback.23274db5.png";